interface InfoRowProps {
  icon: React.ComponentType<{ className?: string }>
  label: string
  children: React.ReactNode
}

export function InfoRow({ icon: Icon, label, children }: InfoRowProps) {
  return (
    <div className="flex gap-2 text-sm">
      <div className="flex items-center h-5 shrink-0">
        <Icon className="size-4 text-muted-foreground" />
      </div>
      <div className="flex-1 min-w-0">
        <span className="text-muted-foreground mr-2">{label}:</span>
        <span className="text-foreground">{children}</span>
      </div>
    </div>
  )
}
